import React from 'react';
import PropTypes from 'prop-types';

import CartPlus from '../../icons/CartPlus';

import './cart-header.scss';

class CartHeaderButton extends React.Component {
  componentDidMount() {
    const nav = document.querySelector('#mainNav');
    this.hasNav = !!nav;
    this.hasNav && nav.classList.add('navbar--with-cart');
  }

  render() {
    const { cart, handleClick, isStatic } = this.props;
    const aloneClass = this.hasNav ? '' : 'header-cart--alone';
    const staticClass = isStatic ? 'header-cart--static' : '';
    const rootClassName = `header-cart ${aloneClass} ${staticClass}`;
    return <div className={rootClassName}>
      <button type="button" className="header-cart__button btn btn-primary" onClick={handleClick}>
        <CartPlus className="mr-1" />
        <span className="header-cart__text">Koszyk </span>
        <span className="badge badge-primary">{cart.length || 0}</span>
        <span className="sr-only">pozycji w koszyku</span>
      </button>
    </div>;
  }
}

CartHeaderButton.propTypes + {
  cart: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
  static: PropTypes.bool,
}

export default CartHeaderButton;
